"use client";

import { useEffect, useRef } from "react";

import { trackCatalogPageView } from "@/lib/analytics";

export function AnalyticsCatalogContext({
  entityType,
  qualityTier,
}: {
  entityType: "artist" | "company" | "release" | "work";
  qualityTier: number;
}) {
  const tracked = useRef(false);
  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackCatalogPageView({ entityType, qualityTier });
  }, [entityType, qualityTier]);

  return null;
}

export function catalogSeoQualityTier(
  entity: { seo?: { qualityTier: number } | null } | null | undefined,
): number {
  return entity?.seo?.qualityTier ?? 9;
}
